import { render, staticRenderFns } from "./component-linkto.vue?vue&type=template&id=222f5552"
import script from "./component-linkto.vue?vue&type=script&lang=js"
export * from "./component-linkto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports